import { z } from 'zod/v4';

const SlotMappingSourceRuntype = z.discriminatedUnion('kind', [
    z.object({ kind: z.literal('section'), templateId: z.string(), sectionId: z.string() }),
    z.object({ kind: z.literal('line_item'), templateId: z.string(), lineItemId: z.string() }),
    z.object({ kind: z.literal('exported_variable'), variableId: z.string() }),
    z.object({ kind: z.literal('manual') }),
]);

export const QuotationTemplateSlotMappingRuntype = z.object({
    slot: z.string(),
    source: z.union([SlotMappingSourceRuntype, z.array(SlotMappingSourceRuntype)]),
});

export const QuotationTemplateSectionRuntype = z.object({
    id: z.string(),
    label: z.string(),
    enabled: z.boolean(),
});

export const QuotationTemplateRuntype = z.object({
    id: z.string(),
    name: z.string(),
    body: z.string(),
    inputs: z.record(z.string(), z.string()),
    sections: z.array(QuotationTemplateSectionRuntype),
    slot_mappings: z.array(QuotationTemplateSlotMappingRuntype),
    // Opaque preview sample data owned/shaped by the frontend (a `QuotationData`).
    // Typed as `unknown` here to avoid an http-client -> lumiquote-frontend dependency;
    // the frontend narrows it to `QuotationData`. `null` for templates saved before
    // sample data was persisted.
    data: z.unknown().nullish(),
    created_at: z.string(),
    updated_at: z.string(),
});

export type QuotationTemplateDTO = z.infer<typeof QuotationTemplateRuntype>;

export const CreateQuotationTemplateRequestRuntype = z.object({
    name: z.string(),
    body: z.string(),
    inputs: z.record(z.string(), z.string()),
    sections: z.array(QuotationTemplateSectionRuntype),
    slot_mappings: z.array(QuotationTemplateSlotMappingRuntype),
    data: z.unknown().optional(),
});

export const UpdateQuotationTemplateRequestRuntype = z.object({
    name: z.string().optional(),
    body: z.string().optional(),
    inputs: z.record(z.string(), z.string()).optional(),
    sections: z.array(QuotationTemplateSectionRuntype).optional(),
    slot_mappings: z.array(QuotationTemplateSlotMappingRuntype).optional(),
    data: z.unknown().optional(),
});
